import React from "react";

const Table = React.forwardRef(({ className = "min-w-full divide-y divide-gray-200", children, style, ...props}, ref) => (
  <table ref={ref} style={style} className={className} {...props}>
    {children}
  </table>
));

export default Table